module.exports = __webpack_public_path__ + "img/room.362144fb.svg";